export default __webpack_public_path__ + "static/media/vector-2.963bc199.png";